import { Component } from '@angular/core';
import {ProgressSpinnerModule } from 'primeng/progressspinner'
import { LoaderService } from '../../services/loader/loader.service';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-loader',
  standalone: true,
  imports: [ProgressSpinnerModule ,CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent {
  isLoading: Subject<boolean> = this.loaderService.isLoading;

  constructor(private loaderService: LoaderService) {
  }

}
